import Vue from 'vue';
import Vuex from 'vuex';

import {} from './mutation-types';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    course: {},
  },
  getters: {
    course: state => state.course,
  },
  mutations: {

  },
  actions: {

  },
});

export default store;
